import type { SVGProps } from 'react';

interface OrdersIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export function OrdersIcon({ className, ...props }: OrdersIconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M1.79975 10.9532L2.09177 9.23946C2.43739 7.21294 2.6094 6.19927 3.29344 5.59924C3.97749 5 4.95995 5 6.92407 5H10.9771C12.9412 5 13.9237 5 14.6077 5.60004C15.2918 6.20007 15.4638 7.21294 15.8094 9.23946L16.1014 10.9532C16.5799 13.7573 16.8183 15.159 16.083 16.0799C15.347 17.0007 13.9869 17.0007 11.2691 17.0007H6.63205C3.91348 17.0007 2.5542 17.0007 1.81815 16.0807C1.08211 15.159 1.32212 13.7573 1.79975 10.9532Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.3501 6.59936L5.52211 4.19121C5.58426 3.32443 5.97243 2.51337 6.6085 1.92127C7.24457 1.32918 8.08132 1 8.95032 1C9.81932 1 10.6561 1.32918 11.2921 1.92127C11.9282 2.51337 12.3164 3.32443 12.3785 4.19121L12.5505 6.59936"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
